import { useEffect, useState } from 'react';
import { subscribeMembership } from '../services/liveMemberships';
import { subscribeMembershipLessons } from '../services/liveV2';
import { lessonOfMonth } from '../utils/monthlyCoaching';
import type { LiveCallBooking, LiveMembership } from '../types/liveCall';

/** A Monthly Coaching lesson's place in its month ("Lesson 2 of 4"), from its month's lessons; null for any other lesson. */
export function useMonthPlace(booking: LiveCallBooking, uid: string | undefined, isCoach: boolean): { n: number; total: number } | null {
  const [m, setM] = useState<LiveMembership | null>(null);
  const [lessons, setLessons] = useState<LiveCallBooking[]>([]);
  const membershipId = booking.membershipId ?? '';
  useEffect(() => (membershipId ? subscribeMembership(membershipId, setM) : undefined), [membershipId]);
  useEffect(() => (membershipId && uid
    ? subscribeMembershipLessons(uid, isCoach ? 'coach' : 'player', membershipId, setLessons) : undefined),
  [membershipId, uid, isCoach]);
  return membershipId && m ? lessonOfMonth(m, lessons, booking.id) : null;
}
